import {
  dialogFlowIntentNames,
  goodDialogFromIntents
} from 'features/Engagement/constants'
import { useState } from 'react'

import styles from './SidebarIntents.module.scss'

const SidebarIntents = ({ threads, onChangeActiveIntent }) => {
  const [selectedIntent, setSelectedIntent] = useState(null)

  const uniqueIntents = [
    ...new Set(
      Object.values(threads)
        .filter(v => v.lastMessageBotIntent)
        .map(v => v.lastMessageBotIntent)
        .filter(intent => goodDialogFromIntents.includes(intent))
    )
  ]

  function handleIntentClick(intent) {
    if (selectedIntent === intent) {
      onChangeActiveIntent(null)
      setSelectedIntent(null)
    } else {
      onChangeActiveIntent(intent)
      setSelectedIntent(intent)
    }
  }

  if (uniqueIntents.length === 0) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Filter by topics</div>
      <div className={styles.tagsHolder}>
        {uniqueIntents.map(i => (
          <button
            key={i}
            onClick={() => handleIntentClick(i)}
            className={
              selectedIntent === i ? styles.intentButtonSelected : styles.intentButton
            }
          >
            {dialogFlowIntentNames[i]}
          </button>
        ))}
      </div>
    </div>
  )
}

export default SidebarIntents
